import { render, staticRenderFns } from "./AppAgreement.vue?vue&type=template&id=f70f43a8&scoped=true&"
import script from "./AppAgreement.vue?vue&type=script&lang=js&"
export * from "./AppAgreement.vue?vue&type=script&lang=js&"
import style0 from "./AppAgreement.vue?vue&type=style&index=0&id=f70f43a8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f70f43a8",
  null
  
)

export default component.exports